"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetIDPSService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const auth3_consensus_1 = require("@branch-ts/auth3-consensus");
const verset_business_1 = require("@project/verset_business");
const biome_ai_1 = require("@branch-ts/biome-ai");
const biome_ai_web_1 = require("@branch-ts/biome-ai-web");
const practice_probe_client_1 = require("@branch-ts/practice-probe-client");
const idps_consensus_1 = require("@branch-ts/idps-consensus");
const log_consensus_1 = require("@branch-ts/log-consensus");
const notable_affair_consensus_1 = require("@branch-ts/notable-affair-consensus");
const practice_auth3_web_1 = require("@branch-ts/practice-auth3-web");
const practice_idps_web_1 = require("@branch-ts/practice-idps-web");
const practice_omni_web_1 = require("@branch-ts/practice-omni-web");
const puri_1 = require("@branch-ts/puri");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const feature_1 = require("./service.Verset/feature");
const service_VersetBusinessGuide_1 = require("./service.VersetBusinessGuide");
const service_VersetProbe_1 = require("./service.VersetProbe");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_VersetScopedContent_1 = require("./service.VersetScopedContent");
const service_VersetWorkerFacility_1 = require("./service.VersetWorkerFacility");
class IDPSNotificationSyncLogic {
    static { this.PROVIDER_NAME = "verset-idps-review"; }
    static { this.NOTIFICATION_TYPE = "verset-idps-review"; }
    constructor(option) {
        this.option = option;
        this.clearAllSupport = null;
    }
    start() {
        this.option.notableAffairAccumulator.events.listenBy(this, "change", (payload) => {
            this.syncEssenseURI(payload.essenseURI);
        });
        practice_omni_web_1.UINotificationBroadcastMechanism.events.listenBy(this, "reviewed", (option) => {
            void this.option.notableAffairAccumulator.eraseNotableAffair({
                essenseURI: option.essenseURI,
            });
        });
        this.bindClearAllSupport(practice_omni_web_1.OmniCenter.center || null);
        practice_omni_web_1.OmniCenter.events.listenBy(this, "center", (omniCenter) => {
            this.bindClearAllSupport(omniCenter);
        });
        practice_omni_web_1.NotificationOmniSupport.events.listenBy(this, "interacted", async (event) => {
            const notification = event.notification;
            if (notification.providerName !== IDPSNotificationSyncLogic.PROVIDER_NAME) {
                return;
            }
            const essenseURI = (notification.data?.essenseURI || notification.essenceURI);
            if (!essenseURI) {
                return;
            }
            const care = this.option.notableAffairAccumulator.cares[essenseURI];
            if (!care || care.reviewedAt >= care.progressedAt) {
                return;
            }
            await this.option.notableAffairAccumulator.eraseNotableAffair({
                essenseURI,
            });
        });
        for (const essenseURI of Object.keys(this.option.notableAffairAccumulator.cares)) {
            this.syncEssenseURI(essenseURI);
        }
    }
    bindClearAllSupport(omniCenter) {
        this.clearAllSupport?.cancel();
        const notificationManager = omniCenter?.notificationManager;
        this.clearAllSupport = notificationManager?.support({
            clearAll: (payload) => {
                const essenceURIs = payload.notifications
                    .filter((notification) => notification.providerName === IDPSNotificationSyncLogic.PROVIDER_NAME)
                    .map((notification) => (notification.data?.essenseURI || notification.essenceURI))
                    .filter((essenseURI) => !!essenseURI);
                if (essenceURIs.length <= 0) {
                    return;
                }
                void Promise.all(essenceURIs.map(async (essenseURI) => {
                    const care = this.option.notableAffairAccumulator.cares[essenseURI];
                    if (!care || care.reviewedAt >= care.progressedAt) {
                        return;
                    }
                    await this.option.notableAffairAccumulator.eraseNotableAffair({
                        essenseURI,
                    });
                }));
            },
        }) || null;
    }
    syncEssenseURI(essenseURI) {
        const care = this.option.notableAffairAccumulator.cares[essenseURI];
        const omniCenter = practice_omni_web_1.OmniCenter.center;
        if (!care || care.reviewedAt >= care.progressedAt) {
            omniCenter?.removeNotification?.({
                identifier: essenseURI,
                reason: "reviewed",
            });
            return;
        }
        ;
        practice_omni_web_1.OmniCenter.notifyNotification({
            uri: essenseURI,
            identifier: essenseURI,
            essenceURI: essenseURI,
            providerName: IDPSNotificationSyncLogic.PROVIDER_NAME,
            type: IDPSNotificationSyncLogic.NOTIFICATION_TYPE,
            notifiedAt: care.progressedAt,
            removeOnInteract: true,
            presentation: {
                title: care.title,
                description: care.hint || "IDPS needs review",
                tags: ["idps", "review"],
            },
            data: {
                essenseURI,
                progressedAt: care.progressedAt,
                reviewedAt: care.reviewedAt,
                info: care.info,
            },
        });
    }
}
let VersetIDPSService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetIDPSService = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetIDPSService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        constructor(option) {
            this.option = option;
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetBusinessGuideService: service_VersetBusinessGuide_1.VersetBusinessGuideService,
                VersetProbeService: service_VersetProbe_1.VersetProbeService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                VersetScopedContentService: service_VersetScopedContent_1.VersetScopedContentService,
                VersetWorkerFacilityService: service_VersetWorkerFacility_1.VersetWorkerFacilityService,
                SessionService: practice_auth3_web_1.SessionService,
            });
            this.mainSpaceProvider = null;
            this.threadContainer = null;
            this.threadContainerAccess = null;
            this.defaultIterator = null;
            this.llmSpecEnvironment = {
                iterators: {},
                variants: {},
            };
            this.notableAffairAccumulator = null;
            this.notableAffairNotificationSyncLogic = null;
            this.integratedThreadContainerAccess = {
                ensure: async (option) => {
                    const access = practice_idps_web_1.IntelligenceCenter.main?.threads || this.threadContainerAccess;
                    if (!access) {
                        return [, "EnvironmentNotMatch", new Error("Thread container access is not ready")];
                    }
                    return await access.ensure(option);
                },
                interact: async (option) => {
                    const access = practice_idps_web_1.IntelligenceCenter.main?.threads || this.threadContainerAccess;
                    if (!access) {
                        return [, "EnvironmentNotMatch", new Error("Thread container access is not ready")];
                    }
                    return await access.interact(option);
                },
            };
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        get sessionStorage() {
            return this.deps.VersetRequireLoginService.sessionStorageProvider;
        }
        get integratedThreadAccess() {
            return this.integratedThreadContainerAccess;
        }
        async resolveLLMSpecEnvironment() {
            const [result] = await this.server.rpcs.VersetUserLLMRouteService.getMyAvailableIterators();
            const iterators = {};
            for (const iterator of result?.iterators || []) {
                iterators[iterator.id] = iterator;
            }
            return {
                iterators,
                variants: {},
            };
        }
        async makeEnvironment(option) {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            const fileSystemContext = option.idps.asFileSystemContext();
            return [{
                    environment: {
                        ...(0, biome_ai_web_1.createLocalNotificationEnvironment)(),
                        internet: {
                            internetProvider: this.server.rpcs.VersetUserInternetService,
                        },
                        browser: this.option.browser,
                        idps: {
                            idpsProvider: (uri) => {
                                return seqop_consensus_1.MediatorRegistryMechanism.ensure({
                                    uri,
                                });
                            },
                        },
                        verse: {
                            verseProvider: (uri) => {
                                return seqop_consensus_1.MediatorRegistryMechanism.ensure({
                                    uri,
                                });
                            },
                        },
                        sc: {
                            scProvider: (uri) => {
                                return this.deps.VersetScopedContentService.getMediator({
                                    uri,
                                });
                            },
                        },
                        terminals: {
                            probes: () => this.deps.VersetProbeService.getProbeInventory(),
                            probe: (option) => this.deps.VersetProbeService.requestProbe(option),
                            resolveProbeHost: (option) => this.deps.VersetProbeService.resolveProbeHost(option),
                            resolveProbeTerminal: (option) => this.deps.VersetProbeService.resolveProbeTerminal(option),
                            endpoints: () => this.deps.VersetProbeService.getTerminalFileSystemBindings(),
                            hostExecEndpoints: () => this.deps.VersetProbeService.getHostExecFileSystemBindings(),
                        },
                        mcp: {
                            servers: () => (0, practice_probe_client_1.getMcpServers)(this.deps.VersetProbeService.probeSessionManager),
                            resolve: (server) => (0, practice_probe_client_1.resolveMcpAccess)(this.deps.VersetProbeService.probeSessionManager, server),
                            bucketURI: agreement.particulars.versetWebapp.bucketURI,
                        },
                        fs: {
                            fileSystemContext,
                            bucketURI: agreement.particulars.versetWebapp.bucketURI,
                            resolveUtilAccess: (to) => this.deps.VersetProbeService.resolveUtilAccess(to),
                        },
                    },
                }];
        }
        registerStaticDutyDeclarations() {
            if (!this.defaultIterator) {
                return;
            }
            const vendor = this.deps.VersetRequireLoginService.agreement.vendor;
            const deepHeroURI = idps_consensus_1.GuildProtocol.HeroURI.builtIn({
                vendor,
                name: "verset-deep-work",
            });
            const stableAttunements = idps_consensus_1.BuiltInAttunementMechanism.getDefaultSelections();
            const allWares = (0, idps_consensus_1.getRegisteredBuiltInShellwareURIs)({ vendor });
            const deepWares = allWares.filter((uri) => {
                return uri !== idps_consensus_1.GuildProtocol.ShellwareURI.builtIn({
                    vendor,
                    name: "fmt",
                });
            });
            idps_consensus_1.BuiltInHeroMechanism.register({
                declaration: {
                    uri: deepHeroURI,
                    name: "Verset Deep Work",
                    iterator: this.defaultIterator,
                    preference: verset_business_1.VersetProduct.llm.defaultPreference,
                    ghost: idps_consensus_1.BuiltInDefaultURI,
                    wares: deepWares,
                    attunements: stableAttunements,
                },
            });
            idps_consensus_1.BuiltInDutyMechanism.register({
                declaration: {
                    uri: idps_consensus_1.GuildProtocol.DutyURI.builtIn({
                        vendor,
                        name: "verset-deep-work",
                    }),
                    name: "Verset Deep Work",
                    description: {
                        mime: "text/markdown",
                        content: "Deep sequential work mode for a BAC-bound topic.",
                    },
                    hero: deepHeroURI,
                },
            });
        }
        makeBuiltinDutyCandidates() {
            return idps_consensus_1.BuiltInDutyMechanism.getAll().map((declaration) => {
                return idps_consensus_1.BuiltInDutyMechanism.makeIntention({ duty: declaration });
            });
        }
        makeMainSpaceProvider() {
            return {
                getSpec: async () => [{
                        supportedVendors: [this.me.app.vendor],
                        defaultVendor: this.me.app.vendor,
                        spec: {
                            specKind: "space",
                            protocol: "idps",
                            kind: "idp",
                            kindSpec: "idp+idps",
                        },
                    }],
                get: async (option) => {
                    const [result, reason, ...errors] = await this.getIdpScope(option);
                    if (reason) {
                        return [, reason, ...errors];
                    }
                    return [{
                            uri: result.uri,
                            data: result.data,
                            name: result.data.name,
                        }];
                },
                query: async (option) => {
                    const [result, reason, ...errors] = await this.listUserIdpScopes({
                        offset: option?.offset,
                        count: option?.count,
                    });
                    if (reason) {
                        return [, reason, ...errors];
                    }
                    return [{
                            items: (result.scopes || []).map(scope => ({
                                uri: scope.scopeURI,
                                data: {
                                    id: scope.id,
                                    name: scope.name,
                                    namespace: scope.namespace,
                                    title: scope.title,
                                    vendor: scope.vendor,
                                    description: scope.description,
                                    version: scope.version,
                                    ownershipURI: scope.userURI,
                                },
                            })),
                        }];
                },
                create: async (option) => {
                    return await this.createIdpScope({
                        name: option.data.name || "",
                        namespace: option.data.namespace || this.me.app.vendor,
                        title: option.data.title,
                        description: option.data.description,
                        purpose: option.data.purpose,
                        bindingURI: option.data.bindingURI,
                    });
                },
                remove: async () => {
                    return [, "NotAvailable", new Error("Main IDPS space remove is not available")];
                },
            };
        }
        async setupNotableAffair() {
            const session = this.deps.SessionService.session;
            if (!session?.accountId) {
                return;
            }
            const ownershipURI = auth3_consensus_1.Auth3Protocol.AccountURI.build({
                vendor: this.me.app.vendor,
                id: session.accountId,
            });
            this.notableAffairAccumulator = new notable_affair_consensus_1.NotableAffairAccumulator({
                ownershipURI,
                access: {
                    createConsumerStream: async () => {
                        return await this.server.rpcs.VersetUserNotableAffairService.createMyNotableAffairConsumerStream({});
                    },
                    eraseNotableAffair: async (option) => {
                        return await this.server.rpcs.VersetUserNotableAffairService.eraseMyNotableAffair({
                            essenseURI: option.essenseURI,
                        });
                    },
                },
            });
            await this.notableAffairAccumulator.start();
            this.notableAffairNotificationSyncLogic = new IDPSNotificationSyncLogic({
                notableAffairAccumulator: this.notableAffairAccumulator,
            });
            this.notableAffairNotificationSyncLogic.start();
        }
        createIdpExplorer() {
            return new practice_idps_web_1.IdpExplorer({
                procedureRegistry: idps_consensus_1.IdpsProcedureRegistryMechanism.ensure(this.deps.SessionService.situations.get("auth")),
                vendor: this.me.app.vendor,
                space: this.mainSpaceProvider,
                store: this.sessionStorage,
                editorKind: this.deps.VersetRequireLoginService.agreement.particulars.versetWebapp.idps.editorKind,
                threadContainerAccess: this.integratedThreadContainerAccess,
                llmSpecEnvironment: this.llmSpecEnvironment,
                digestIterator: this.defaultIterator,
                digestLimit: 32,
                chatRenderContext: (0, practice_idps_web_1.createDefaultChatRenderContext)(),
            });
        }
        makeIdpExplorer(option) {
            const isNewIdps = !!idps_consensus_1.IDPSProtocol.Signal.NewIdps.parse(option.uri);
            if (!isNewIdps && !idps_consensus_1.IDPSProtocol.IDPScopeURI.parse(option.uri)) {
                return null;
            }
            return practice_idps_web_1.IdpExplorer.ensure(option.uri, {
                procedureRegistry: idps_consensus_1.IdpsProcedureRegistryMechanism.ensure(this.deps.SessionService.situations.get("auth")),
                vendor: this.me.app.vendor,
                space: this.mainSpaceProvider,
                store: this.sessionStorage,
                editorKind: this.deps.VersetRequireLoginService.agreement.particulars.versetWebapp.idps.editorKind,
                threadContainerAccess: this.integratedThreadContainerAccess,
                llmSpecEnvironment: this.llmSpecEnvironment,
                digestIterator: this.defaultIterator,
                digestLimit: 32,
                chatRenderContext: (0, practice_idps_web_1.createDefaultChatRenderContext)(),
                initialNarrative: option.initialNarrative,
                onIdpsCreated: option.onIdpsCreated,
            }, this.makeBuiltinDutyCandidates());
        }
        async initialize() {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            const vendor = agreement.vendor;
            const editorKind = agreement.particulars.versetWebapp.idps.editorKind;
            const defaultSpaceURI = agreement.particulars.versetWebapp.idps.spaceURI;
            this.scopeSpaceURI = defaultSpaceURI;
            this.llmSpecEnvironment = await this.resolveLLMSpecEnvironment();
            const [availableResult] = await this.server.rpcs.VersetUserLLMRouteService.getMyAvailableIterators();
            this.defaultIterator = availableResult?.default || availableResult?.iterators?.[0]?.id || null;
            // Default duties snapshot all registered wares, so their registration
            // belongs to the same service and must happen immediately before that
            // snapshot rather than rely on unrelated UI service ordering.
            (0, biome_ai_1.FatRegisterBuiltInShellware)({
                vendor,
            }).resigerAll();
            await this.setupNotableAffair();
            await (0, feature_1.IDPSEditorIntegrationFeature)({
                editorKind,
            });
            this.registerStaticDutyDeclarations();
            this.mainSpaceProvider = this.makeMainSpaceProvider();
            puri_1.PuriSpaceRegistryMechanism.register({
                name: `${vendor}+scopeSpace+idps`,
                registry: (option) => {
                    if (option.uri !== defaultSpaceURI) {
                        return null;
                    }
                    return this.mainSpaceProvider;
                },
            });
            this.registerIdpsMediator(vendor);
            const reactor = new idps_consensus_1.ExchangeReactor({
                exchange: this.deps.VersetBusinessGuideService.gateLLMExchange(this.server.rpcs.VersetUserLLMRouteService, { source: "IDPS assistant" }),
            });
            this.threadContainer = new idps_consensus_1.IdpsThreadContainer({
                uri: idps_consensus_1.IDPSProtocol.ThreadContainerURI.build({
                    vendor,
                    id: "browser-tab-local",
                }),
                makeEnvironment: this.makeEnvironment.bind(this),
                reactor,
            });
            this.threadContainerAccess = new idps_consensus_1.ThreadContainerDirectAccess({
                container: this.threadContainer,
            });
            (0, feature_1.IDPSExplorerIntegrationFeature)({
                editorKinds: [
                    agreement.particulars.versetWebapp.verse.editorKind,
                    editorKind,
                ],
                scopeSpaceURI: defaultSpaceURI,
                createExplorer: this.createIdpExplorer.bind(this),
                makeDutyCandidates: this.makeBuiltinDutyCandidates.bind(this),
            });
            log_consensus_1.Logger.log("VersetIDPSService ready", {
                defaultSpaceURI,
            });
        }
        registerIdpsMediator(vendor) {
            seqop_consensus_1.MediatorRegistryMechanism.register({
                name: `${vendor}+idps`,
                registry: (option) => {
                    const scopeInfo = idps_consensus_1.IDPSProtocol.IDPScopeURI.parse(option.uri);
                    if (scopeInfo?.vendor === vendor) {
                        const provider = new seqop_consensus_1.ReconnectingArbitratorProvider(async () => {
                            const [res, reason, ...errors] = await this.getIdpScopeProvider({ uri: option.uri });
                            if (reason || !res?.provider)
                                throw new Error(reason || errors?.[0]?.message || "Failed to get idps scope provider");
                            return res.provider;
                        }, this.server.authorizedConnection);
                        const mediator = new idps_consensus_1.IdpsMediator({ arbitrator: provider, uri: option.uri });
                        mediator.shouldCacheLocally = true;
                        return provider.own(mediator);
                    }
                    if (scopeInfo?.vendor === "BrowserSession") {
                        return new idps_consensus_1.IdpsMediator({
                            arbitrator: new seqop_consensus_1.AccessArbitratorProvider(option.uri, this.deps.VersetWorkerFacilityService.sessionArbitratorAccessProvider),
                            uri: option.uri,
                        });
                    }
                    return null;
                },
            });
        }
        async createIdpScope(option) {
            return await this.server.rpcs.VersetUserIdpsService.createIdpScope(option);
        }
        async getIdpScope(option) {
            return await this.server.rpcs.VersetUserIdpsService.getIdpScope(option);
        }
        async getMyMainIdpSpace() {
            return await this.server.rpcs.VersetUserIdpsService.getMyMainIdpSpace({});
        }
        async getMainIdpSpaceProvider() {
            return await this.server.rpcs.VersetUserIdpsService.getMainIdpSpaceProvider({});
        }
        async getIdpScopeProvider(option) {
            return await this.server.rpcs.VersetUserIdpsService.getIdpScopeProvider(option);
        }
        async listUserIdpScopes(option = {}) {
            return await this.server.rpcs.VersetUserIdpsService.listUserIdpScopes(option);
        }
    };
    return VersetIDPSService = _classThis;
})();
exports.VersetIDPSService = VersetIDPSService;
